import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {pieChartOptions} from "./pieChartOptions";

const cloneDeep = require('lodash.clonedeep');

export default class PieChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pieChartOptions: cloneDeep(pieChartOptions),
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.data !== nextProps.data) {
            const pieChartOptions = cloneDeep(this.state.pieChartOptions);
            pieChartOptions.series[0].data = nextProps.data;
            this.setState({pieChartOptions});
        }
    }

    render() {
        const {title, total, data} = this.props;
        const pieChartOptions = this.state.pieChartOptions;

        return (
            <div className='PieChart'>
                <div className='chart-container'>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={pieChartOptions}
                    />
                </div>
                <div className='chart-legend'>
                    {data.map((item, index) => (
                        <div className='chart-legend-item' key={index}>
                            <div className='chart-legend-value'>
                                {((item.y * 100) / total).toFixed(1)}%
                            </div>
                            <div className='chart-legend-name'>
                                <div
                                    className='chart-legend-color'
                                    style={{background: item.color}}
                                />
                                {item.name}
                            </div>
                        </div>
                    ))}
                </div>
                <div className='stats-subtitle'>{title}</div>
            </div>
        );
    }
}